import type { StyleSystemProps } from '@withjoy/joykit';
import { ButtonV2, Flex, styled, Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Box)``;
export const StyledBackgroundImage = styled(Box)``;
export const StyledOverlay = styled(Flex)``;
export const StyledTitle = styled(Box)``;
export const StyledButtonContainer = styled(Box)``;
export const StyledButton = styled(ButtonV2)``;

const containerStyles: StyleSystemProps = {
  paddingX: [3, 0],
  paddingY: [pxToRem(10), 0],
};

const backgroundImageStyles = (backgroundImageURL: string): StyleSystemProps => ({
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundImage: `url('${backgroundImageURL}')`,
  overflow: 'hidden',
  borderRadius: [8, 0],
  width: '100%',
});

const overlayStyles: StyleSystemProps = {
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  paddingX: 6,
  paddingY: pxToRem(72),
};

const titleStyles: StyleSystemProps = {
  marginTop: 9,
  color: 'white',
  textAlign: 'center',
};

const buttonContainerStyles: StyleSystemProps = {
  marginTop: 7,
};

export const styles = {
  container: containerStyles,
  backgroundImage: backgroundImageStyles,
  title: titleStyles,
  buttonContainer: buttonContainerStyles,
  overlay: overlayStyles,
};
